import React from 'react';
import { connect } from 'react-redux';
import { setFilters, setFilteredAssets, getAssets, executeFilters } from '../../actions';
import Form from 'react-jsonschema-form-carbon';
import funcTranslateHelper from '../../i18next/funcTranslateHelper';

import './filter.scss';
import moment from 'moment';

import { CustomSelectCarbon, CustomDatePicker } from './CustomComponents';

const fields = {
  customSelect: CustomSelectCarbon,
  customDatePicker: CustomDatePicker
};

class AssetsFilter extends React.Component {
  constructor (props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      form: '',
      assetsListDates: {
        from: moment()
          .subtract(7, 'days')
          .toDate(),
        to: moment().toDate()
      },
      typingTimeout: 0
    };
  }

  componentDidMount () {
    const { assets } = this.props;
    const assetTypes = {};
    document.addEventListener('keydown', this._handleKeyDown.bind(this));
    assets &&
      assets.map(x => {
        if (x.assetType && !assetTypes[x.assetType]) {
          assetTypes[x.assetType] = false;
        }
        return 0;
      });
  }

  _handleKeyDown (event) {
    // enter key code is 13
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  checkTyping = event => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      form: event.formData,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.onChange(event);
      }, 50)
    });
  };

  onChange = async formdata => {
    if (Object.entries(formdata.formData).length >= 1) {
      let filters = Object.entries(formdata.formData).filter(([key, value]) =>
        !(value === undefined || (Array.isArray(value) && value.length <= 0))
      );
      filters = filters.filter(value => value[0] !== 'datePicker');
      this.props.setFilters(filters);
      if (formdata.formData.datePicker && formdata.formData.datePicker.newDates) {
        this.props.setNewAssets(
          undefined,
          formdata.formData.datePicker.newDates.from,
          formdata.formData.datePicker.newDates.to
        );
      } else {
        this.props.executeFilters(filters);
      }
    }
  };

  ObjectFieldTemplate ({ TitleField, properties, title, description }) {
    return (
      <div className='bx--row filter-box'>
        {properties.map(prop => {
          const customClass = prop.name === 'datePicker' ? 'dp-custom-width' : '';
          return (
            <div
              className={`bx--col-sm-12 bx--col-md-4 bx--col-lg-2 ${customClass}`}
              key={prop.content.key}
            >
              {funcTranslateHelper(prop.content)}
            </div>
          );
        })}
        {description}
      </div>
    );
  }

  render () {
    const { configFile } = this.props;
    return (
      <Form
        noValidate
        schema={configFile.filters.schema}
        formData={this.state.form}
        onChange={event => this.checkTyping(event)}
        ObjectFieldTemplate={this.ObjectFieldTemplate}
        uiSchema={configFile.filters.uiSchema}
        fields={fields}
      >
        <button
          // onClick={() => console.log('Filter Data: ', this.state.form)}
          style={{ display: 'none' }}
        >
          Submit
        </button>
      </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    assets: state.assets,
    configFile: state.configFile,
    myHeight: state.myHeight
  };
};

const mapDispatchToProps = dispatch => ({
  filteredAssets: filter => {
    dispatch(setFilteredAssets(filter));
  },
  setFilters: entries => {
    dispatch(setFilters(entries));
  },
  setNewAssets: (token, from, to) => {
    dispatch(getAssets(token, from, to));
  },
  executeFilters: () => {
    dispatch(executeFilters());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetsFilter);
